// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
export var skeletonColors = function(mode) {
    var bg = background(mode);
    return {
        background: bg.state.hover0,
        background2: bg.state.hover0
    };
};

//# sourceMappingURL=skeletonColors.js.map